<template>
  <el-container>
    <el-header height="20px">
      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="hedgeAccountEnum">
          <el-table-column width="200" property="key" label="对冲账号"></el-table-column>
          <el-table-column width="500" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">对冲账号说明</el-button>
      </el-popover>
      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="binanceDepositWithdrawDesc">
          <el-table-column width="200" property="key" label="币安充提"></el-table-column>
          <el-table-column width="300" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">币安充提说明</el-button>
      </el-popover>
      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="huobiDepositWithdrawDesc">
          <el-table-column width="200" property="key" label="火币充提"></el-table-column>
          <el-table-column width="300" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">火币充提说明</el-button>
      </el-popover>
      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="huobiTransferDesc">
          <el-table-column width="200" property="key" label="火币划转"></el-table-column>
          <el-table-column width="300" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">火币划转说明</el-button>
      </el-popover>
    </el-header>
    <el-main>
      <el-tabs v-model="activeName">
        <el-tab-pane label="历史资产快照" name="part1">
          <div>
            <el-card>
              <div class="block">
                <el-form :inline="true">
                  <el-form-item label="日期">
                    <el-date-picker
                        v-model="dateRange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="平台账号:">
                    <el-select v-model="exchange" placeholder="请选择平台账号">
                      <el-option v-for="item in hedgeAccountEnum" :key="item.key" :value="item.key" :label="item.label"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="币种类型:">
                    <!--            <el-input v-model="coinType" placeholder="请输入币种类型"></el-input>-->
                    <el-autocomplete popper-class="my-autocomplete" v-model="coinType" :fetch-suggestions="querySearch" placeholder="请输入币种类型" @select="handleSelect">
                      <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"></i>
                      <template slot-scope="{ item }"><div class="name">{{ item.value }}</div></template>
                    </el-autocomplete>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryHedgeBalanceBook">查询</el-button>
                  </el-form-item>
                </el-form>
                <div class="top" v-if="isShow">
                  <el-table :data="tableData" style="width: 100%" max-height="1000" border>
                    <el-table-column prop="exchange" label="对冲账号" sortable></el-table-column>
                    <el-table-column prop="coin" label="币种类型" sortable></el-table-column>
                    <el-table-column prop="available" label="可用资产" sortable></el-table-column>
                    <el-table-column prop="frozen" label="冻结资产" sortable></el-table-column>
                    <el-table-column prop="total" label="当前资产" sortable></el-table-column>
                    <el-table-column prop="deposit" label="充值资金" sortable></el-table-column>
                    <el-table-column prop="withdraw" label="提现资金" sortable></el-table-column>
                    <!--            <el-table-column prop="transferIn" label="划转入" sortable></el-table-column>-->
                    <!--            <el-table-column prop="transferOut" label="划转出" sortable></el-table-column>-->
                    <el-table-column prop="updateTime" label="更新时间" sortable></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                  </el-table>
                  <el-pagination background
                                 layout="total, sizes, prev, pager, next, jumper"
                                 :page-size="pageSize"
                                 :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                                 :total="total"
                                 :current-page="currentPageNum"
                                 @size-change="handleSizeChange"
                                 @current-change="handleCurrentChange">
                  </el-pagination>
                  <div style="text-align:right">
                    <el-button type="success" plain @click="exportExcel(params1)">全量导出excel</el-button>
                    <el-button type="success" plain @click="exportExcel(params)">当前页导出excel</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="充提明细" name="part2">
          <deposit-withdraw></deposit-withdraw>
        </el-tab-pane>
        <el-tab-pane label="成交明细" name="part3">
          <deal-records></deal-records>
        </el-tab-pane>
        <el-tab-pane label="划转明细" name="part4">
          <transfer-records></transfer-records>
        </el-tab-pane>
        <el-tab-pane label="手动查询明细" name="part5">
          <lack-records></lack-records>
        </el-tab-pane>
        <el-tab-pane label="去中心化资产" name="part6">
          <decentralization-balance></decentralization-balance>
        </el-tab-pane>
        <el-tab-pane label="去中心化交易" name="part7">
          <decentralization-transaction></decentralization-transaction>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import './store'
import {mapActions, mapState} from "vuex";
import utils from "@/entries/HedgeCenter/BalanceBook/utils";
import DepositWithdraw from "@/entries/HedgeCenter/BalanceBook/DepositWithdraw";
import DealRecords from "@/entries/HedgeCenter/BalanceBook/DealRecords";
import TransferRecords from "@/entries/HedgeCenter/BalanceBook/TransferRecords";
import LackRecords from "@/entries/HedgeCenter/BalanceBook/LackRecords";
import DecentralizationBalance from "@/entries/HedgeCenter/BalanceBook/DecentralizationBalance";
import DecentralizationTransaction from "@/entries/HedgeCenter/BalanceBook/DecentralizationTransaction";

const columns=[
  {title:'对冲账号',key:'exchange'},
  {title:'币种类型',key:'coin'},
  {title:'可用资产',key:'available'},
  {title:'冻结资产',key:'frozen'},
  {title:'当前资产',key:'total'},
  {title:'充值资金',key:'deposit'},
  {title:'提现资金',key:'withdraw'},
  {title:'更新时间',key:'updateTime'},
  {title:'创建时间',key:'createTime'}
]


export default {
  name: "index",
  components: {DepositWithdraw, DealRecords, TransferRecords, LackRecords, DecentralizationBalance, DecentralizationTransaction},
  comments:{
    'DepositWithdraw':DepositWithdraw,
    'DealRecords':DealRecords,
    'TransferRecords':TransferRecords, 'LackRecords':LackRecords,
    'DecentralizationBalance': DecentralizationBalance,
    'DecentralizationTransaction': DecentralizationTransaction
  },
  data(){
    return {
      pages:0,
      total:0,
      buffer:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      exchange:'',
      coinType: '',
      activeName:'part1',
      dateRange:[],
      tableData:[],
      restaurants:[],
    }
  },

  watch:{
  },

  methods:{
    ...mapActions('balanceReconciliation', ['getHedgeAccountEnum']),

    exportExcel(requestData){
      utils.queryHedgeBalanceBookAll(requestData).then((response)=>{
        let startTime = utils.getLocalTime(this.dateRange[0])
        let endTime = utils.getLocalTime(this.dateRange[1])
        let title = '对冲资产快照' + startTime + '-' + endTime
        let data = response.data
        for (let key in data){
          data[key].createTime = utils.getLocalTime(data[key].createTime)
          data[key].updateTime = utils.getLocalTime(data[key].updateTime)
        }
        utils.export2Excel(columns, data, title)
      })
    },

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryHedgeBalanceBook()
    },

    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryHedgeBalanceBook()
    },

    queryHedgeBalanceBook(){
      if (this.dateRange.length === 0){
        this.$message.error("请选择日期")
        return
      }
      if (this.exchange === ""){
        this.$message.error("请选择平台账号")
        return
      }
      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.buffer !== this.paramsBak){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }
      utils.queryHedgeBalanceBook(this.params).then((response)=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current

        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].createTime = utils.getLocalTime(tableData[key].createTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
        }
        this.tableData = tableData
      })
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => { return (restaurant.value.toLowerCase.indexOf(queryString.toLowerCase()) === 0); };
    },
    handleSelect(item) {},
    handleIconClick(ev) {}

  },

  computed: {
    ...mapState('balanceReconciliation', ['hedgeAccountEnum', 'pickerOptions', 'binanceDepositWithdrawDesc',
      'huobiDepositWithdrawDesc', 'huobiTransferDesc']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        coinType: this.coinType,
        exchange: this.exchange,
        pageSize: this.pageSize,
        pageNum: this.currentPageNum
      };
    },
    params1() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        coinType: '',
        exchange: '',
      };
    },
    paramsBak() {
      return {
        dateRange:this.dateRange,
        coinType: this.coinType,
        exchange: this.exchange,
      };
    },
  },

  created() {
    this.getHedgeAccountEnum()
  }
}
</script>

<style scoped>

</style>